import { create } from "zustand";
import { createSelectors } from "~utils/zustand";

export interface State {
	scroll: boolean;
	isPipedriveSuccess: boolean;
}

export interface Actions {
	setScroll: (data: State["scroll"]) => void;
	setIsPipedriveSuccess: (data: State["isPipedriveSuccess"]) => void;
}

export const initialState: State = {
	scroll: false,
	isPipedriveSuccess: false,
};

const _useStore = create<State & Actions>((set, _get) => ({
	...initialState,
	setScroll: (scroll) => set({ scroll }),
	setIsPipedriveSuccess: (isPipedriveSuccess) => set({ isPipedriveSuccess }),
}));

const {
	use,
	setState: _setState,
	getState: _getState,
} = createSelectors(_useStore);

export const useScroll = () => use.scroll();
export const useIsPipedriveSuccess = () => use.isPipedriveSuccess();
export const useSetScroll = () => use.setScroll();
export const useSetIsPipedriveSuccess = () => use.setIsPipedriveSuccess();
